module.exports = __webpack_public_path__ + "img/cardio12.5752beb3.jpg";